export const TASK_TITLE_MAX_LENGTH = 50;
//# sourceMappingURL=common.js.map